<template>
    <div class="foodmash">
        <div @click="handleClose" class="foodmash-close">
            <i class="lnr lnr-cross"></i>
        </div>
        <div class="foodmash-status">
            <i class="lnr lnr-cross"></i>
            <i class="lnr lnr-heart"></i>
        </div>
        <div id="foodmash-loader" class="foodmash-loader"></div>
        <div class="foodmash-deck">
            <foodmash-deck-empty v-if="deckIsEmpty" :message-to-show="noRestaurantsLeftMessage"></foodmash-deck-empty>
            <foodmash-default-card v-else-if="showDefaultCard" @defaultswiped="onDefaultSwiped"
                                   :default-message="defaultMessage" ref="defaultCard"></foodmash-default-card>
            <foodmash-ad v-else-if="showAd"
                         @adswiped="onAdSwiped"
                         :iso-app-link="isoAppLink"
                         :iso-app-title="isoAppTitle"
                         :android-app-link="androidAppLink"
                         :android-app-title="androidAppTitle"
                         ref="adCard"></foodmash-ad>
            <foodmash-card v-else
                           v-for="(card, index) in cards"
                           :key="index"
                           :swiped="card.swiped"
                           :card-offset="cardOffset"
                           :image="card.image"
                           :restaurant-name="card.restaurantName"
                           :restaurant-slug="card.restaurantSlug"
                           :restaurant-address="card.restaurantAddress"
                           :restaurant-city="card.restaurantCity"
                           :restaurant-country="card.restaurantCountry"
                           :restaurant-coordinates="card.restaurantCoordinates"
                           :restaurant-categories="card.restaurantCategories"
                           @swiped="onCardSwiped"
                           v-bind:style="{ 'z-index': cards.length - index }"
                           ref="cards"
            ></foodmash-card>
        </div>
        <div v-if="deckIsEmpty"></div>
        <div class="foodmash-buttons" v-else>
            <button @click="handleNopeClick" :aria-label="dislikeLable"><i class="lnr lnr-cross"></i></button>
            <button @click="handleLoveClick" :aria-label="likeLable"><i class="lnr lnr-heart"></i></button>
        </div>
    </div>
</template>

<script>
import FoodmashCard from './FoodmashCard';
import FoodmashDefaultCard from "./FoodmashDefaultCard.vue";
import FoodmashAd from "./FoodmashAd.vue";
import FoodmashDeckEmpty from "./FoodmashDeckEmpty.vue";
import {v4 as uuidv4} from 'uuid';

export default {
    components: {
        FoodmashCard,
        FoodmashDefaultCard,
        FoodmashAd,
        FoodmashDeckEmpty
    },
    props: {
        imagesPhp: Object | Array,
        restaurantName: String,
        restaurantSlug: String,
        restaurantAddress: String,
        restaurantCity: String,
        restaurantCountry: String,
        restaurantCoordinates: String,
        restaurantCategories: Object | Array,
        defaultMessage: String,
        noRestaurantsLeftMessage: String,
        likeLable: String,
        dislikeLable: String,
        // closeAdMessage: String,
        isoAppLink: String,
        isoAppTitle: String,
        androidAppLink: String,
        androidAppTitle: String,
    },
    data() {
        return {
            cards: [],
            swipeCounter: 0,
            adSwiped: false,
            deckIsEmpty: false,
        }
    },
    computed: {
        cardOffset() {
            let cardOffset = 0;
            this.cards.forEach(function (card) {
                if (card.swiped) {
                    cardOffset++;
                }
            });
            return cardOffset;
        },
        showDefaultCard() {
            if (this.cards.length === 0) {
                return true;
            }

            if (this.cards.length === this.cardOffset) {
                return true;
            }

            return false;
        },
        showAd() {
            if (this.showDefaultCard) {
                return false;
            }

            if (this.deckIsEmpty) {
                return false;
            }

            if (this.adSwiped) {
                return false;
            }

            return this.swipeCounter > 0 && ((this.swipeCounter % 5) === 0);
        }
    },
    methods: {
        onCardSwiped: function (payload) {
            this.swipeCounter++;
            this.adSwiped = false;

            let {index, swipeDirection} = payload;
            this.cards[index].swiped = true;

            let likeType = 'dislike';
            if (swipeDirection === 'swiperight') {
                likeType = 'like';
            }

            let token = this.getFoodmashToken();
            this.sendLike(token, this.cards[index].id, likeType);
        },
        onDefaultSwiped: function (swipeDirection) {
            if (swipeDirection === 'swipeleft') {
                this.handleClose();
            } else if (swipeDirection === 'swiperight') {
                let token = this.getFoodmashToken();
                this.setNewImages(token);
            }
        },
        onAdSwiped: function () {
            this.adSwiped = true;
        },
        handleClose: function () {
            this.$el.parentElement.remove();
            this.$destroy();
        },
        handleNopeClick: function () {
            if (this.showDefaultCard) {
                this.$refs.defaultCard.swipe('swipeleft');
                return;
            }

            if (this.showAd) {
                this.$refs.adCard.swipe('swipeleft');
                return;
            }

            const card = this.$refs.cards[this.cardOffset];
            if (card) {
                card.swipe('swipeleft');
            }
        },
        handleLoveClick: function () {
            if (this.showDefaultCard) {
                this.$refs.defaultCard.swipe('swiperight');
                return;
            }

            if (this.showAd) {
                this.$refs.adCard.swipe('swiperight');
                return;
            }

            const card = this.$refs.cards[this.cardOffset];
            if (card) {
                card.swipe('swiperight');
            }
        },
        getFoodmashToken: function () {
            let token = localStorage.getItem('foodmash-token');
            if (token) {
                return token;
            }

            token = uuidv4();
            token = token.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '');
            localStorage.setItem('foodmash-token', token);
            return token;
        },
        getBaseUrl: function () {
            return window.location.protocol + "//" + window.location.hostname;
        },
        getRestaurantMeta: function (slug) {
            let restaurantMeta = localStorage.getItem(slug);
            if (restaurantMeta) {
                restaurantMeta = JSON.parse(restaurantMeta);

                // restaurant meta should be valid only for 6 hours
                const sixHoursInMilliseconds = 6 * 60 * 60 * 1000;
                const currentTimestamp = Date.now();

                if (currentTimestamp - sixHoursInMilliseconds > restaurantMeta.created_at) {
                    localStorage.removeItem(slug); // remove old meta from local storage
                    return null;
                }

                return restaurantMeta;
            }

            return null;
        },
        setRestaurantMeta: function (slug, restaurantMeta) {
            let newMeta = this.getRestaurantMeta(slug);
            if (newMeta) {
                newMeta.current_page = restaurantMeta.current_page;
                newMeta.last_page = restaurantMeta.last_page;
            } else {
                newMeta = {
                    current_page: restaurantMeta.current_page,
                    last_page: restaurantMeta.last_page,
                    created_at: Date.now()
                };
            }

            localStorage.setItem(slug, JSON.stringify(newMeta));
        },
        setNewImages: function (token) {
            document.getElementById('foodmash-loader').style.display = 'block';

            let self = this;
            self.cards = [];
            const baseUrl = this.getBaseUrl();

            let page = 1;
            let restaurantMeta = this.getRestaurantMeta(this.restaurantSlug);
            if (restaurantMeta) {
                page = restaurantMeta.current_page;
                if (restaurantMeta.current_page < restaurantMeta.last_page) {
                    page++;
                } else {
                    page = 1;
                }
            }

            axios.get(`${baseUrl}/api/v1/auth/foodmash-swipe/images`, {
                params: {
                    page: page,
                    coordinates: this.restaurantCoordinates,
                    device_token: token
                }
            }).then(function (response) {
                response = response.data;

                self.setRestaurantMeta(self.restaurantSlug, response.meta);

                let cardData = [];

                let promises = response.data.map(function (restaurant) {
                    return self.checkImageResolution(restaurant.image_url)
                        .then(function (resolutionIsGood) {
                            if (resolutionIsGood) {
                                cardData.push({
                                    id: restaurant.id.toString(),
                                    image: restaurant.image_url,
                                    restaurantName: restaurant.restaurant_name,
                                    restaurantSlug: restaurant.restaurant_slug,
                                    restaurantAddress: restaurant.restaurant_address,
                                    restaurantCity: restaurant.restaurant_city,
                                    restaurantCountry: restaurant.restaurant_country,
                                    restaurantCoordinates: `${restaurant.restaurant_coordinates.lat}:${restaurant.restaurant_coordinates.lon}`,
                                    restaurantCategories: restaurant.restaurant_categories,
                                    swiped: false
                                });
                            }
                        })
                        .catch(function (error) {
                            // do nothing
                        });
                });

                Promise.all(promises).then(function () {
                    document.getElementById('foodmash-loader').style.display = 'none';

                    self.cards = cardData;

                    if (self.cards.length === 0) {
                        self.deckIsEmpty = true;
                    }
                });
            }).catch(function (error) {
                // do nothing
            });
        },
        sendLike: function (token, id, likeType) {
            const baseUrl = this.getBaseUrl();

            axios.post(`${baseUrl}/api/v1/auth/foodmash-swipe/images/like`, {
                device_token: token,
                swipe_id: id,
                like_type: likeType
            }).then(function (response) {
                // do nothing
            }).catch(function (error) {
                // do nothing
            });
        },
        checkImageResolution: function (imageUrl) {
            return new Promise(function (resolve, reject) {
                let img = new Image();
                img.src = imageUrl;
                img.onload = function () {
                    if (img.width >= 200 && img.height >= 200) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                }
                img.onerror = function () {
                    reject(false);
                }
            });
        },
        handleMobileGalleryClick(event) {
            const clickedCardIndex = this.cards.findIndex(card => card.id === event.detail);
            if (clickedCardIndex !== -1) {
                const clickedCard = this.cards.splice(clickedCardIndex, 1)[0];
                this.cards.unshift(clickedCard);
            }
        },
    },
    created() {
        window.addEventListener('mobile-gallery-clicked', this.handleMobileGalleryClick);

        for (let key in this.imagesPhp) {
            if (this.imagesPhp.hasOwnProperty(key)) {
                if (this.imagesPhp[key].startsWith('http') === false) {
                    continue;
                }

                this.checkImageResolution(this.imagesPhp[key])
                    .then((resolutionIsGood) => {
                        if (resolutionIsGood) {
                            this.cards.push({
                                id: key.toString(),
                                image: this.imagesPhp[key],
                                restaurantName: this.restaurantName,
                                restaurantSlug: this.restaurantSlug,
                                restaurantAddress: this.restaurantAddress,
                                restaurantCity: this.restaurantCity,
                                restaurantCountry: this.restaurantCountry,
                                restaurantCoordinates: this.restaurantCoordinates,
                                restaurantCategories: this.restaurantCategories,
                                swiped: false
                            });
                        }
                    })
                    .catch(function (error) {
                        // do nothing
                    });
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('mobile-gallery-clicked', this.handleMobileGalleryClick);
    }
}
</script>

<style lang="scss">
@import "../../sass/frontend/components/foodmash.scss";
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/FoodmashDeck.vue